module.exports = __webpack_public_path__ + "img/default.301a6735.png";